var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.screenType === 'desktop')?_c('my-lessons-desktop',{attrs:{"details":_vm.details,"class-id":_vm.classId,"course-id":_vm.courseId,"course-name":_vm.course.title}}):_c('my-lessons-mobile',{attrs:{"details":_vm.details,"class-id":_vm.classId,"course-id":_vm.courseId,"course-name":_vm.course.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }